var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{class:_vm.online ? 'connection-indicator--online' : 'connection-indicator--offline',attrs:{"id":"connection-indicator","aria-label":_vm.$t(_vm.statusToken),"title":_vm.$t(_vm.statusToken),"role":"img"}},[_vm._v(" "+_vm._s(_vm.online ? _vm.icons.mdiWifi : _vm.icons.mdiWifiOff)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }